import { render, staticRenderFns } from "./UserKnowledgeDetail.vue?vue&type=template&id=6838ccec&scoped=true&"
import script from "./UserKnowledgeDetail.vue?vue&type=script&lang=js&"
export * from "./UserKnowledgeDetail.vue?vue&type=script&lang=js&"
import style0 from "./UserKnowledgeDetail.vue?vue&type=style&index=0&id=6838ccec&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6838ccec",
  null
  
)

export default component.exports